import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import dayjs from 'dayjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { CheckInService } from '../../../../services/check-in.service';
import { ModalService } from '../../../../services/modal.service';
import { AlertComponent } from '../../../atoms/alert/alert.component';
import { Alert, AlertTypeEnum } from '../../../atoms/alert/alert.types';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';

@Component({
  selector: 'app-modal-check-in-export',
  imports: [
    ModalHeaderComponent,
    MatDialogContent,
    MatFormFieldModule,
    MatDatepickerModule,
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    AlertComponent,
    MatDialogActions,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './modal-check-in-export.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCheckInExportComponent {
  protected RequestStateEnum = RequestStateEnum;

  private readonly checkInService = inject(CheckInService);
  private readonly modalService = inject(ModalService);

  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null, Validators.required),
    end: new FormControl<Date | null>(null, Validators.required),
  });

  alert: Alert | null = null;
  requestState = signal<RequestStateEnum | null>(null);

  public triggerDataExport(): void {
    const start = dayjs(this.range.controls.start.value);
    const end = dayjs(this.range.controls.end.value);
    this.requestState.set(RequestStateEnum.PENDING);

    this.checkInService.triggerCheckInDataExport(start, end).subscribe({
      next: () => this.modalService.close(),
      error: () => {
        this.requestState.set(RequestStateEnum.ERROR);
        this.alert = {
          message: 'Fehler beim Exportieren der Daten.',
          type: AlertTypeEnum.ERROR,
        };
      },
    });
  }
}
